import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

export interface TransitionSpringConfig {
  type: 'spring';
  stiffness: number;
  damping: number;
  mass: number;
}

export interface CheckInTransitionConfig {
  /** Spring config for cloud animation */
  spring: TransitionSpringConfig;
  /** Whether auto-navigate timer is disabled (dev mode) */
  disableAutoNavigate: boolean;
  /** Whether to show replay button (dev mode) */
  showReplay: boolean;
}

const PRODUCTION_CONFIG: CheckInTransitionConfig = {
  spring: { type: 'spring', stiffness: 120, damping: 18, mass: 1 },
  disableAutoNavigate: false,
  showReplay: false,
};

export const DEV_CONFIG: CheckInTransitionConfig = {
  spring: { type: 'spring', stiffness: 30, damping: 18, mass: 1 },
  disableAutoNavigate: true,
  showReplay: true,
};

const CheckInTransitionConfigContext = createContext<CheckInTransitionConfig>(PRODUCTION_CONFIG);

export function CheckInTransitionConfigProvider({
  config,
  children,
}: {
  config: CheckInTransitionConfig;
  children: ReactNode;
}) {
  return (
    <CheckInTransitionConfigContext.Provider value={config}>
      {children}
    </CheckInTransitionConfigContext.Provider>
  );
}

export function useTransitionConfig(): CheckInTransitionConfig {
  return useContext(CheckInTransitionConfigContext);
}
